<template>
  <div class="publiContainer">
    <div class="top">
      <span>行业列表</span>
    </div>
    <div>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab=" 行业列表">
          <div class="container">
            <div class="containerTop">
              <a-button type="primary" @click="increaseIndustry" style="margin-right: 5px">新增行业</a-button>
              <a-button type="primary" @click="sumDelete" style="background-color: red; border: 0">批量删除</a-button>
            </div>
            <div class="containerSearch">
              <a-input
                class="a_select_self margin_self"
                v-model="searchData.industryName"
                allowClear
                placeholder="行业名称"
                @keyup.enter.native="search"
              />
              <!-- <a-input class="a_select_self margin_self" v-model=" searchData.subName" allowClear placeholder="行业子类" /> -->
              <a-button type="primary" @click="search" style="margin: 5px 0">查询</a-button>
              <a-button type="primary" @click="reset" style="margin-right: 5px">重置</a-button>
            </div>
            <div class="containerCenter" id="content_main_center_scroll">
              <!-- 表格区域 -->
              <a-table
                :data-source="dataList"
                bordered
                :loading="loading"
                :pagination="false"
                ref="dataListRef"
                :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
                :row-selection="{ selectedRowKeys: selectedRowKeys[pagination.current], onChange: onSelectChange }"
              >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
                  <template scope="text, record, index">
                    {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                  </template>
                </a-table-column>
                <a-table-column key="industryName" title="行业名称" ellipsis="true" data-index="industryName" />
                <a-table-column key="categoryName" title="所属项目" ellipsis="true" data-index="categoryName" />
                <a-table-column key="creator" title="创建人" ellipsis="true" data-index="creator" />
                <a-table-column key="createTime" title="创建时间" ellipsis="true" data-index="createTime" />

                <a-table-column title="操作" width="260px">
                  <template scope="text,record">
                    <a @click="detailIndustry(record)">详情</a>
                    <a-divider type="vertical" />
                    <a @click="editIndustry(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="deleteIndustry(record)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
              <div class="pageBottom">
                <a-pagination
                  v-model="pagination.current"
                  show-size-changer
                  :page-size.sync="pagination.pageSize"
                  :total="pagination.totalCount"
                  @showSizeChange="onShowSizeChange"
                  :pageSizeOptions="['10', '20', '30', '40', '50']"
                  @change="onShowSizeChange"
                />
              </div>
              <!-- <Pagination 
                            v-model="pagination.current"
                            :total="pagination.totalCount"
                            show-size-changer
                            :page-size="pagination.pageSize"
                             @onShowSizeChange="onShowSizeChange"
                          ></Pagination> -->
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="检测类别表" force-render>
          <div class="container">
            <div class="containerTop">
              <a-button type="primary" @click="addCategory" style="margin-right: 5px">新增检测类别</a-button>
              <a-button type="primary" @click="someDelete" style="background-color: red; border: 0">批量删除</a-button>
            </div>
            <div class="containerSearch">
              <a-input
                class="a_select_self margin_self"
                v-model="searchData1.industryName"
                allowClear
                placeholder="所属行业"
                @keyup.enter.native="searchCategory"
              />
              <a-input
                class="a_select_self margin_self"
                v-model="searchData1.pollutantName"
                allowClear
                placeholder="检测类别"
                @keyup.enter.native="searchCategory"
              />
              <!-- <a-input class="a_select_self margin_self" v-model=" searchData1.subName" allowClear placeholder="行业子类" /> -->
              <a-button type="primary" @click="searchCategory" style="margin: 5px 0">查询</a-button>
              <a-button type="primary" @click="resetCategory" style="margin-right: 5px">重置</a-button>
            </div>
            <div class="containerCenter" id="content_main_center_scroll">
              <a-table
                :data-source="categoryList"
                bordered
                :loading="loading"
                :pagination="false"
                ref="categoryListRef"
                :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
                :row-selection="{ selectedRowKeys: selectedRowKeys1[pagination1.current], onChange: onSelectChange1 }"
              >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
                  <template scope="text, record, index">
                    {{ (pagination1.current - 1) * pagination1.pageSize + index + 1 }}
                  </template>
                </a-table-column>
                <a-table-column key="industryName" title="所属行业" ellipsis="true" data-index="industryName" />
                <a-table-column key="natureName" title="检测性质" ellipsis="true" data-index="natureName" />
                <a-table-column key="pollutantName" title="检测类别" ellipsis="true" data-index="pollutantName" />
                <a-table-column key="creator" title="创建人" ellipsis="true" data-index="creator" />
                <a-table-column key="createTime" title="创建时间" ellipsis="true" data-index="createTime" />
                <a-table-column title="操作" width="260px">
                  <template scope="text,record">
                    <a @click="detailCategory(record)">详情</a>
                    <a-divider type="vertical" />
                    <a @click="editCategory(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="deleteCategory(record)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
              <div class="pageBottom">
                <a-pagination
                  v-model="pagination1.current"
                  show-size-changer
                  :page-size.sync="pagination1.pageSize"
                  :total="pagination1.totalCount"
                  @showSizeChange="onShowSizeChange1"
                  :pageSizeOptions="['10', '20', '30', '40', '50']"
                  @change="onShowSizeChange1"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="检测物质价表">
          <div class="container">
            <div class="containerTop">
              <a-button type="primary" @click="addPollution" style="margin-right: 5px">新增污染物</a-button>
              <a-button type="primary" @click="subDeleteElement" style="background-color: red; border: 0"
                >批量删除</a-button
              >
            </div>
            <div class="containerSearch">
              <a-select
                class="a_select_self margin_self"
                allowClear
                placeholder="所属分类"
                v-model="searchData2.subcategoryId"
                style="width: 160px"
                show-search
                :filter-option="filterOption"
              >
                <a-select-option :value="item.categoryId" v-for="(item, index) in list" :key="index">
                  {{ item.categoryName }}
                </a-select-option>
              </a-select>
              <!-- <a-input class="a_select_self margin_self" v-model=" searchData2.category" allowClear placeholder="所属分类" @keyup.enter.native="searchElement"/> -->
              <a-input
                class="a_select_self margin_self"
                v-model="searchData2.factorName"
                allowClear
                placeholder="物质名称"
                @keyup.enter.native="searchElement"
              />
              <a-button type="primary" @click="searchElement" style="margin: 5px 0">查询</a-button>
              <a-button type="primary" @click="resetElement" style="margin-right: 5px">重置</a-button>
            </div>
            <div class="containerCenter" id="content_main_center_scroll">
              <!-- 表格区域  -->
              <a-table
                :data-source="elementList"
                bordered
                :loading="loading"
                :pagination="false"
                ref="elementListRef"
                :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
                :row-selection="{ selectedRowKeys: selectedRowKeys2[pagination2.current], onChange: onSelectChange2 }"
              >
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="100px">
                  <template scope="text, record, index">
                    {{ (pagination2.current - 1) * pagination2.pageSize + index + 1 }}
                  </template>
                </a-table-column>
                <a-table-column key="category" title="所属分类" ellipsis="true" data-index="category" />
                <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" />
                <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
                <a-table-column key="price" title="单价" ellipsis="true" data-index="price" />
                <a-table-column title="操作" width="260px">
                  <template scope="text,record">
                    <a @click="detailElement(record)">详情</a>
                    <a-divider type="vertical" />
                    <a @click="editElement(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="deleteElement(record)">删除</a>
                  </template>
                </a-table-column>
              </a-table>
              <div class="pageBottom">
                <a-pagination
                  v-model="pagination2.current"
                  show-size-changer
                  :page-size.sync="pagination2.pageSize"
                  :total="pagination2.totalCount"
                  @showSizeChange="onShowSizeChange2"
                  :pageSizeOptions="['10', '20', '30', '40', '50']"
                  @change="onShowSizeChange2"
                />
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- 行业添加/编辑/详情 -->
    <AddIndustry
      :addCategoryList="addCategoryList"
      :type="type"
      :category="category"
      :industryVisible="industryVisible"
      @changeIndustryVisible="changeIndustryVisible"
      @refreshList="getIndustryList"
    ></AddIndustry>
    <!-- 新增检测类别 -->
    <AddCategory
      ref="addCategory"
      :categoryVisible="categoryVisible"
      :examineList="examineList"
      @changeCategoryVisible="changeCategoryVisible"
      @getCategoryData="getCategoryData"
      @refreshPollutant="getPollutant"
    ></AddCategory>
    <!-- 编辑检测类别 -->
    <EditCategory
      ref="editCategory"
      :matterList="matterList"
      :numb="numb"
      :editCategoryVisible="editCategoryVisible"
      @changeEditCategoryVisible="changeEditCategoryVisible"
      @changePollution="getPollution"
      @getData="getPollutant"
    ></EditCategory>
    <Pollution
      :category="category"
      :kind="kind"
      :pollutionVisible="pollutionVisible"
      @changePollutionVisible="changePollutionVisible"
      :pollutionList="pollutionList"
      @changePollutionList="getBase"
    ></Pollution>
  </div>
</template>

<script>
import AddIndustry from './components/addIndustry.vue'
import AddCategory from './components/addCategory.vue'
import EditCategory from './components/editCategory.vue'
import Pollution from './components/pollution.vue'
import Pagination from '@/components/pagination/index.vue'

import {
  getIndusryInfoUserList,
  getCategoryList,
  deleteIndustryInfo,
  getPollutantType,
  getRelationBaseFactor,
  deleteCategoryPollutant,
  baseFactorDelete,
  getChargeList,
} from '@/api/surrounding'
import { baseFactor, delete_factor } from '@/api/Industry'

export default {
  components: {
    AddIndustry,
    AddCategory,
    EditCategory,
    Pollution,
    Pagination,
  },
  data() {
    return {
      list: [],
      scroll_y: 150,
      // 检测物质价表参数
      // 搜索参数
      searchData2: {
        subcategoryId: undefined,
        category: '',
        factorName: '',
      },
      elementList: [
        {
          industryName: '',
          subName: '',
        },
      ],
      selectedRowKeys2: {
        1: [],
      },
      pollutionVisible: false,
      kind: 0,
      pagination2: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      pollutionData: [],

      //检测类别参数
      matterList: [],
      pagination1: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      searchData1: {
        industryName: '',
        pollutantName: '',
      },
      categoryList: [],
      // selectedRowKeys1: '',
      selectedRowKeys1: {
        1: [],
      },
      // 新增弹窗
      categoryVisible: false,
      // 编辑、详情弹窗
      editCategoryVisible: false,
      numb: 0,
      //详情列表数据
      substanceList: {},
      examineList: [],
      categoryData: {},
      rowData: {},
      deleteCategoryList: [],
      // 行业弹窗
      industryVisible: false,
      type: 0,
      searchData: {
        industryName: '',
      },
      dataList: [],
      selectedRowKeys: {
        1: [],
      },
      pagination: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      // 项目
      category: '',
      addCategoryList: {
        categoryName: '',
        industryName: '',
        createTime: '',
        createBy: '',
      },
      deleteIndustryList: [],
      pollutionList: {
        category: '',
        factorName: '',
        subcategoryId: '',
      },
    }
  },
  created() {
    this.getIndustryList()
    this.getCategory()
    // this.getPollutant()
    // this.getBase()
    //获取类别
    getChargeList({
      parentId: 1000,
    }).then((res) => {
      if (res.code == 200) {
        this.list = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      console.log(max_h, 'max_h===================================')
      // setTimeout(() => {
      this.scroll_y = max_h - $('.ant-table-header').height() + 260
      // }, 1000)
    })
  },
  methods: {
    callback(key) {
      this.$nextTick((res) => {
        switch (key) {
          case '1':
            this.getIndustryList()
            break
          case '2':
            this.getPollutant()
            break
          case '3':
            this.getBase()
            break
        }
      })
    },
    // 检测物质价表查询
    searchElement() {
      this.pagination2.current = 1
      this.pagination2.pageSize = 10
      this.getBase()
    },
    // 重置
    resetElement() {
      this.searchData2 = {}
      this.getBase()
    },
    //获取检测物质价表
    // categoryId: 1000
    getBase() {
      baseFactor({
        subcategoryId: this.searchData2.subcategoryId,
        factorName: this.searchData2.factorName,
        pageNum: this.pagination2.current,
        pageSize: this.pagination2.pageSize,
        categoryId: 1000,
      }).then((res) => {
        if (res.code == 200) {
          this.elementList = res.data
          this.pagination2.totalCount = res.total
        }
      })
    },
    //分页
    onShowSizeChange2(current, pageSize) {
      console.log(current, pageSize)
      this.pagination2.current = current
      this.pagination2.pageSize = pageSize
      //改变完 重新渲染数据
      this.getBase()
    },
    // 获取项目
    getCategory() {
      getCategoryList().then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            if (item.id == 4) {
              this.category = item.categoryName
              console.log(this.category, ' this.category===============')
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取行业列表
    getIndustryList() {
      getIndusryInfoUserList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        industryName: this.searchData.industryName,
        // subName: this.searchData.subName,
        projectId: 4,
      }).then((res) => {
        if (res.code == 200) {
          this.dataList = res.data.list
          this.pagination.totalCount = res.data.totalCount
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //分页
    onShowSizeChange(current, pageSize) {
      console.log(current, pageSize)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      //改变完 重新渲染数据
      this.getIndustryList()
    },

    changeIndustryVisible(data) {
      this.industryVisible = data
    },
    //新增行业
    increaseIndustry() {
      this.type = 0
      this.addCategoryList = {}
      // this.addCategoryList.industryName = this.category
      this.industryVisible = true
      console.log(this.industryVisible, 'this.industryVisiblew')
    },
    //批量删除
    sumDelete() {
      var _this = this
      var obj = _this.deleteIndustryList
      var ids = []
      for (let i in obj) {
        obj[i].forEach((item) => {
          ids.push(item.id)
        })
      }
      if (_this.deleteIndustryList.length) {
        console.log(ids, 'ids=======================')
        this.$confirm({
          title: '是否确认删除?',
          onOk() {
            deleteIndustryInfo(ids).then((res) => {
              if (res.code == 200) {
                _this.$message.success(res.msg)
                _this.selectedRowKeys = ''
                _this.deleteIndustryList = []
                _this.getIndustryList()
              } else {
                _this.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            _this.$message.warning('你点击了取消')
          },
          class: 'test',
        })
      } else {
        this.$message.warning('请至少选中一条数据！')
      }
    },
    // 行业列表查询
    search() {
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.getIndustryList()
    },
    //行业列表重置
    reset() {
      this.searchData = {}
      this.getIndustryList()
    },
    //多选事件
    onSelectChange(selectedRowKeys, val) {
      //  this.selectedRowKeys = selectedRowKeys
      this.selectedRowKeys[this.pagination.current] = selectedRowKeys
      this.getIndustryList()
      this.deleteIndustryList[this.pagination.current] = val
      console.log(selectedRowKeys, val, '111111111111111111111111111')
    },
    //行业编辑
    editIndustry(record) {
      this.addCategoryList = JSON.parse(JSON.stringify(record))
      console.log(this.addCategoryList)
      this.type = 2
      this.industryVisible = true
    },
    //行业详情

    detailIndustry(record) {
      this.addCategoryList = JSON.parse(JSON.stringify(record))
      console.log(this.addCategoryList)
      this.type = 1
      this.industryVisible = true
    },
    //行业删除
    deleteIndustry(record) {
      var _this = this
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          deleteIndustryInfo(record.id).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.msg)
              _this.getIndustryList()
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
        // class: 'test',
      })
    },

    // 危害因素检测类别事件
    getCategoryData(data) {
      this.categoryData = data
    },

    //获取检测类别列表
    getPollutant() {
      getPollutantType({
        pageIndex: this.pagination1.current,
        pageSize: this.pagination1.pageSize,
        industryName: this.searchData1.industryName,
        pollutantName: this.searchData1.pollutantName,
        // subName: this.searchData1.subName,
      }).then((res) => {
        if (res.code == 200) {
          this.categoryList = res.data.list
          this.pagination1.totalCount = res.data.totalCount
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //分页
    onShowSizeChange1(current, pageSize) {
      console.log(current, pageSize)
      this.pagination1.current = current
      this.pagination1.pageSize = pageSize
      //改变完 重新渲染数据
      this.getPollutant()
    },

    //查询
    searchCategory() {
      this.pagination1.current = 1
      this.pagination1.pageSize = 10
      this.getPollutant()
    },
    //重置
    resetCategory() {
      this.searchData1 = {}
      this.getPollutant()
    },
    //多选事件
    onSelectChange1(selectedRowKeys, val) {
      this.selectedRowKeys1[this.pagination1.current] = selectedRowKeys
      this.getPollutant()
      this.deleteCategoryList[this.pagination.current] = val
      //  this.selectedRowKeys = selectedRowKeys
    },
    //批量删除
    someDelete() {
      var _this = this
      var obj = _this.deleteCategoryList
      var ids = []
      for (let i in obj) {
        obj[i].forEach((item) => {
          ids.push(item.id)
        })
      }
      if (_this.deleteCategoryList.length) {
        this.$confirm({
          title: '是否确认删除?',
          onOk() {
            deleteCategoryPollutant(ids).then((res) => {
              if (res.code == 200) {
                _this.$message.success(res.msg)
                _this.selectedRowKeys1 = []
                _this.deleteCategoryList = []
                _this.getPollutant()
              } else {
                _this.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            _this.$message.warning('你点击了取消')
          },
          // class: 'test',
        })
      } else {
        this.$message.warning('请至少选中一条数据！')
      }
    },
    //新增检测类别
    addCategory() {
      // 获取新增列表数据
      // baseFactor({
      //   categoryId: 1002,
      //   subcategoryId: this.categoryData.industryId,
      //   factorName: this.categoryData.pollutantName
      // }).then(res => {
      //   if(res.code == 200) {
      //   this.examineList = res.data
      //   } else {
      //     this.$message.error(res.msg)
      //   }

      // })
      this.$refs.addCategory.init()
      this.categoryVisible = true
    },
    changeCategoryVisible(data) {
      this.categoryVisible = data
    },
    changeEditCategoryVisible(data) {
      this.editCategoryVisible = data
    },
    getPollution(data) {
      //获取当前列表数据
      getRelationBaseFactor({
        id: data.id,
      }).then((res) => {
        if (res.code == 200) {
          this.matterList = res.data.list
        }
      })
      console.log(this.matterList, 'this.matterList================')
    },
    //详情
    detailCategory(record) {
      this.$refs.editCategory.init(JSON.parse(JSON.stringify(record)))
      this.getPollution(record)
      this.editCategoryVisible = true
      this.numb = 1
    },
    //编辑
    editCategory(record) {
      this.$refs.editCategory.init(JSON.parse(JSON.stringify(record)))
      getRelationBaseFactor({
        id: record.id,
      }).then((res) => {
        if (res.code == 200) {
          this.matterList = res.data.list
        }
      })
      this.editCategoryVisible = true
      this.numb = 0
    },
    //删除
    deleteCategory(record) {
      var _this = this
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          deleteCategoryPollutant(record.id).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.msg)
              _this.getPollutant()
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
      })
    },

    //检测物质报价事件
    changePollutionVisible(data) {
      this.pollutionVisible = data
    },
    //添加污染物
    addPollution() {
      this.pollutionList = {}
      ;(this.pollutionVisible = true), (this.kind = 0)
    },
    // 多选
    onSelectChange2(selectedRowKeys, val) {
      this.selectedRowKeys2[this.pagination2.current] = selectedRowKeys
      this.getBase()
      this.pollutionData[this.pagination2.current] = val
    },
    // 详情
    detailElement(record) {
      console.log(record, 'record=================')
      this.pollutionList = JSON.parse(JSON.stringify(record))
      ;(this.pollutionVisible = true), (this.kind = 2)
    },
    // 编辑
    editElement(record) {
      this.pollutionList = JSON.parse(JSON.stringify(record))
      ;(this.pollutionVisible = true), (this.kind = 1)
    },
    // 删除
    deleteElement(row) {
      var _this = this
      var id = row.id
      this.$confirm({
        title: '是否确认删除?',
        onOk() {
          baseFactorDelete(id).then((res) => {
            if (res.code == 200) {
              _this.$message.success(res.msg)
              _this.getBase()
            } else {
              _this.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          _this.$message.warning('你点击了取消')
        },
        // class: 'test',
      })
    },
    // 批量删除
    subDeleteElement() {
      var _this = this
      var obj = _this.pollutionData
      var ids = []
      for (let i in obj) {
        obj[i].forEach((item) => {
          ids.push(item.id)
        })
      }
      if (_this.pollutionData.length) {
        console.log(ids, 'ids=====================')
        console.log('111111111111111111111111111111111111')
        this.$confirm({
          title: '是否确认删除?',
          onOk() {
            baseFactorDelete(ids).then((res) => {
              if (res.code == 200) {
                _this.selectedRowKeys2 = {}
                _this.$message.success(res.msg)
                _this.pollutionData = {}
                _this.getBase()
              } else {
                _this.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            _this.$message.warning('你点击了取消')
          },
          // class: 'test',
        })
      } else {
        this.$message.warning('请至少选中一条数据！')
      }
    },
  },
}
</script>

<style scoped>
.publiContainer {
  background-color: #fff;
  padding-bottom: 40px;
}
.top {
  padding: 15px 10px;
  font-size: 18px;
}
.container {
  padding-left: 10px;
}
.pageBottom {
  margin: 10px;
  display: flex;
  flex-direction: row-reverse;
}
/* .container {
    padding: 5px;
} */
/* .containerTop {
    padding: 10px 10px 10px 0;
} */
</style>